<template>
  <mdb-badge pill :color="getColorByScore(score)" class="score">
    <strong>{{getGradeByScore(score)}}</strong>
  </mdb-badge>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbIcon,
  mdbProgress
} from "mdbvue";

export default {
  name: "ScoreToGapVisualizer",
  props: ["score"],
  data() {
    return {
      //score: 1
    };
  },

  methods: {
    getColorByScore(score) {
      if (score <= 1) return "red";
      if (score <= 2) return "orange";
      if (score <= 3) return "bg-lightGreen";
      if (score <= 4) return "bg-green";
    },
    getTabColorByScore(score) {
      if (score <= 1) return "left-bar-red";
      if (score <= 2) return "left-bar-orange";
      if (score <= 3) return "left-bar-lightGreen";
      if (score <= 4) return "left-bar-green";
    },
    getGradeByScore(score) {
      if (score <= 1) return "Your main gap";
      if (score <= 2) return "Your gap";
      if (score <= 3) return "Your strength";
      if (score <= 4) return "Your main strength";
    }
  },

  components: {
    mdbBadge
  }
};
</script>
